export const EARLY_ACCESS_FORM_LIMIT = 5
export const EARLY_ACCESS_ENTRY_LIMIT = 5
export const EAP_EXPERIMENT_NAME = 'forms_eap_access_treatment'
